//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
	name:'index',
	data(){
		return {
			title:'它品联盟',
			list:[],
			page:1,
      img:'http://static.dev.epetbar.com/static_web/pc/src/images/background/everydayBgNew2.png'
		}
	},
	components:{},
	created(){
		//this.infiniteHandler();
	},
	methods:{
  	infiniteHandler($state){
  		var _self = this;
  		this.$EpetJs.Common.get('union/trial/Main.html?petType=dog&cate=0',{page:this.page}).
  		then( ({data}) =>{
  			if(!data.data.list.length){
  				$state.complete();
  			}else{
  				_self.list = _self.list.concat(data.data.list);
  				_self.page+=1;
  				$state.loaded();
  				// this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
  				
  			}
  		})
  	},
  	rest(){
  		this.list=[];
  		this.$nextTick(() => {
        this.$refs.infiniteLoading.attemptLoad();//重新触发数据加载
      });
  	}
	}
}
